// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import Vuex from 'vuex'
import store from './store/index'
import httpRequest from '@/utils/httpRequest' // api: https://github.com/axios/axios
import {
	isAuth
} from '@/utils'
import VueCookie from 'vue-cookie'
import i18n from '@/lang'
import Lang from '@/components/Lang'
import VuCountryIntl from 'vue-country-intl';
import 'vue-country-intl/lib/vue-country-intl.css'

// #ifdef H5
// uni.getSystemInfo({
// 	success(res) {
// 		if (res.model != 'PC') {
// 			window.location.href = "https://wap.oliender.com"
// 		}
// 	}
// })

let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if(flag) {
        //如果flag不为空，说明可以匹配到，是手机端
        window.location.href = "https://wap.oliender.com"
    }

//#endif

Vue.component('Lang', Lang)
Vue.component(VuCountryIntl.name, VuCountryIntl);
Vue.use(VueCookie)
Vue.use(ElementUI);
Vue.config.productionTip = false

// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.isAuth = isAuth // 权限方法

Vue.use(ElementUI, {
	i18n: (key, value) => i18n.t(key, value)
})
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	i18n,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js